import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";

export async function getProjectKeys(id) {
    return await new API(URL.buildUrl(`projects/${id}/keys`)).get();
  }